module.exports = __webpack_public_path__ + "img/mgh-logo-new.1c91ad7c.svg";